import { IPickerModel } from '@rhybus/api'
import React, { useEffect, useRef, useState } from 'react'

import { mpfAuthCrudHttp } from '../../../assets/ts/api/mpf-auth-crud-http'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { mpfWhoHttp } from '../../../assets/ts/api/mpf-who-http'
import Alert from '../../../components/alert/alert'
import ActionButtons from '../../../components/buttons/action-buttons'
import Buttons from "../../../components/buttons/buttons"
import PageOverlayBusy from '../../../components/page-overlay/page-overlay-busy'
import usePascodeMetadata from '../../../hooks/use-pascode-metadata'
import { MAX_LENGTHS } from '../../../utils/constants/global-constants'
import { NORESULT } from "../../../utils/constants/rhybus-config"
import InputCheckbox from "../../../utils/controls/input-checkbox"
import InputText from '../../../utils/controls/input-text'

let popupTop: number
let xpositionvalue: number
let offsetLeftValue: number
let offsetTopValue: number
let elementHeightValue: number
let offsetWidthValue: number

const AddRemoveUser = ({
    btnActionshowhide,
    fetchUsers,
    inputValues,
    isMenusExpanded,
    rolesToAdd,
    setActionbtnshowhide,
    setShowActionPopups,
    showActionPopups
}: any) => {
    const showhide = { ...btnActionshowhide }
    const removeuser = useRef(null)
    const popupbtnRef = useRef(null)
    const { pascodeMetadata } = usePascodeMetadata({ IsArchived: false })
    const [rolesToDisplay, setRolesToDisplay] = useState<any>(rolesToAdd)
    const [disabledRoles, setDisabledRoles] = useState<any>([])
    const [xpositionvalueupdate, setpopupwidthupdate] = useState<any>()
    const [popupheight, setpopupheight] = useState<any>()
    const [pageOverlay, setPageOverlay] = useState<boolean>(false)
    const [peopleDropdownNames, setPeopleDropdownNames] = useState<string[]>([])
    const [peopleExpand, setPeopleExpand] = useState<Array<IPickerModel>>([])
    const [refreshRoles, setRefreshRoles] = useState<boolean>(false)
    const [searchError, setSearchError] = useState<boolean>(false)
    const [selectedValue, setSelectedValue] = useState<any>({
        id: '',
        mailId: '',
        roles: [],
        title: '',
    })
    const [hasCSSOrMPF, setHasCSSOrMPF] = useState('')
    const [searchedUser, setSearchedUser] = useState('')
    const [togglePopupInfo, setTogglePopupInfo] = useState(false)
    const [roles, setRoles] = useState<string[]>([])
    const [rolesToRemove, setRolesToRemove] = useState<string[]>([])
    const [addedRoles, setAddedRoles] = useState<string[]>([])
    const [currentRoles, setCurrentRoles] = useState<string[]>([])
    const [crossComponentAlert, setCrossComponentAlert] = useState(false)
    const [noProfileAlert, setNoProfileAlert] = useState(false)

    function popupCloseOpenFunctionality(
        type: any,
        value: any,
        top: number,
        xposition: number,
        left: number,
        elementHeight: number,
        offsetWidth: number
    ) {
        popupTop = top
        xpositionvalue = xposition
        offsetLeftValue = left
        offsetTopValue = top
        elementHeightValue = elementHeight
        offsetWidthValue = offsetWidth
        showhide.removeuser = false
        showhide.usersearch = false
        setActionbtnshowhide(showhide)
        if (type) {
            setActionbtnshowhide({ ...showhide, [type]: value })
            setShowActionPopups({ ...showhide, [type]: value })
        }
    }

    useEffect(() => {
        if (!btnActionshowhide.removeuser) {
            setSearchedUser('')
            setSelectedValue({
                id: '',
                mailId: '',
                roles: [],
                title: '',
            })
            setTogglePopupInfo(false)
        }
    }, [btnActionshowhide])

    useEffect(() => {
        setpopupheight(window.innerHeight - (offsetTopValue + 90))
        const popupwidthdata = popupbtnRef.current
            ? popupbtnRef.current.offsetWidth
            : 0
        // setpopupwidth(popupwidthdata)
        if (popupwidthdata < xpositionvalue) {
            xpositionvalue = xpositionvalue - popupwidthdata
            setpopupwidthupdate(xpositionvalue)
        } else if (
            popupwidthdata > offsetLeftValue &&
            popupwidthdata <
            window.innerWidth - (offsetLeftValue + offsetWidthValue)
        ) {
            xpositionvalue = offsetLeftValue
            setpopupwidthupdate(xpositionvalue)
        } else if (
            popupwidthdata > offsetLeftValue &&
            popupwidthdata >
            window.innerWidth - (offsetLeftValue + offsetWidthValue)
        ) {
            xpositionvalue = 0
            setpopupwidthupdate(xpositionvalue)
        }
    }, [showActionPopups])

    const changeUser = async (value: string) => {
        setSearchError(false)
        setTogglePopupInfo(false)
        setSearchedUser(value)
        if (value.trim().length > 2) {
            const userList = [...(await mpfWhoHttp().Picker(value.trim()))]
            const userName = userList.map((item) => item.persona)
            setPeopleDropdownNames([...userName])
            setPeopleExpand(userList)
        }
        if (selectedValue.title !== value) {
            setSelectedValue({ id: '', mailId: '', roles: [], title: '' })
            setRoles([])
        }
    }

    const selectedUser = async (value: string, refreshRoleArr = false) => {
        setSearchedUser(value)
        const user: IPickerModel =
            peopleExpand.find((item) => item.persona === value)
        const id = user.rid
        const mail = user.email
        const userRoles = await mpfAuthCrudHttp().GetUser(user.rid)
        const filteredUserRoles = userRoles?.roles.filter((role) =>
            role !== 'User' && role !== 'AppUser' && role !== 'Admin' &&
            rolesToAdd.includes(role)
        )
        setSelectedValue({
            allRoles: userRoles?.roles ? userRoles?.roles : [],
            id: id,
            mailId: mail,
            roles: filteredUserRoles,
            title: value
        })
        if (refreshRoleArr) setRefreshRoles(true)
    }

    const handleUserSearch = async () => {
        let search = false
        if (selectedValue.roles && selectedValue.id) {
            setRoles(selectedValue.roles ? selectedValue.roles : [])
            setCurrentRoles(selectedValue.roles ? selectedValue.roles : [])
            setTogglePopupInfo(true)
            const filteredRoles = [...rolesToAdd]
            const alreadyAddedRoles: any[] = []

            selectedValue?.allRoles?.map((role: any) => {
                const index = filteredRoles.indexOf(role)
                if (role !== 'User' && role !== 'AppUser' && role !== 'Admin') {
                    if (index !== -1) filteredRoles.splice(index, 1)
                    alreadyAddedRoles.push(role)
                }
            })

            const rolesToDisable: string[] = []

            let assignedComponentCode = -1
            pascodeMetadata.every((pascode) => {
                alreadyAddedRoles.forEach((role) => {
                    if (role === 'CP Owner') return true

                    if (`${pascode.ServicingOrganization.split(' ')[0]} FSS` === role.split('-')[0]) {
                        assignedComponentCode = pascode.AssignedComponentCode
                        return false
                    }
                })
                return true
            })

            if (assignedComponentCode === inputValues.assignedComponentCode ||
                assignedComponentCode === -1) {
                alreadyAddedRoles.forEach((role) => {
                    if (role.includes('Technician') ||
                        role.includes('Supervisor') ||
                        role.includes('Section Chief')
                    ) {
                        const roleSect = role.split('-')[2]
                        const roleSquad = role.split('-')[0]
                        filteredRoles.forEach((filteredRole: string) => {
                            const filteredRoleSect = filteredRole.split('-')[2]
                            const filteredRoleSquad = filteredRole.split('-')[0]
                            if ((roleSect === filteredRoleSect &&
                                roleSquad === filteredRoleSquad &&
                                (filteredRole.includes('Technician') ||
                                    filteredRole.includes('Supervisor') ||
                                    filteredRole.includes('Section Chief'))) ||
                                filteredRole.includes('CSS')
                            ) {
                                rolesToDisable.push(filteredRole)
                                if (hasCSSOrMPF === '') setHasCSSOrMPF('MPF')
                            }
                        })
                    } else if (role.includes('CSS')) {
                        filteredRoles.forEach((filteredRole: string) => {
                            if (!filteredRole.includes('CSS') && filteredRole.includes('FSS-MPF')) {
                                rolesToDisable.push(filteredRole)
                                if (hasCSSOrMPF === '') setHasCSSOrMPF('CSS')
                            }
                        })
                    } else {
                        switch (role) {
                            case 'RegAF Owner':
                                if (inputValues.assignedComponentCode !== 143) {
                                    rolesToDisable.push(...filteredRoles)
                                }
                                break
                            case 'AFRC Owner':
                                if (inputValues.assignedComponentCode !== 145) {
                                    rolesToDisable.push(...filteredRoles)
                                }
                                break
                            case 'ANG Owner':
                                if (inputValues.assignedComponentCode !== 144) {
                                    rolesToDisable.push(...filteredRoles)
                                }
                                break
                            default:
                                if (role.includes('MAJCOM')) {
                                    let sameComponent = false
                                    const filteredPascodeMetadata = pascodeMetadata
                                        .filter((pascode) => {
                                        return pascode.AssignedComponentCode === 
                                            inputValues.assignedComponentCode
                                        })

                                    filteredPascodeMetadata.forEach((pascode) => {
                                        if (role.includes(pascode.ServicingMAJCOM)) {
                                            sameComponent = true
                                        }
                                    })

                                    if (!sameComponent) {
                                        rolesToDisable.push(...filteredRoles)
                                    }
                                }
                                break
                        }
                    }
                })
                setDisabledRoles(rolesToDisable)
            } else {
                setDisabledRoles(filteredRoles)
            }

            setRolesToDisplay(filteredRoles)
            setRolesToRemove([])
            setAddedRoles([])
        } else if (!selectedValue.id) {
            search = true
        }
        setSearchError(search)
    }

    const handleRoleChange = (role: string, removeRoles = false, e) => {
        const tempRoles: string[] = removeRoles ?
            [...rolesToRemove] : [...addedRoles]
        const index = tempRoles.indexOf(role)

        if (index !== -1) {
            tempRoles.splice(index, 1)
        } else {
            tempRoles.push(role)
        }

        if (!removeRoles) {
            const rolesToEnable: string[] = []
            const rolesToDisable: string[] = []
            if (role.includes('Technician') ||
                role.includes('Supervisor') ||
                role.includes('Section Chief')
            ) {
                const roleSect = role.split('-')[2]
                const roleSquad = role.split('-')[0]
                rolesToDisplay.forEach((filteredRole: string) => {
                    const filteredRoleSect = filteredRole.split('-')[2]
                    const filteredRoleSquad = filteredRole.split('-')[0]

                    if ((roleSect === filteredRoleSect &&
                        roleSquad === filteredRoleSquad &&
                        filteredRole.toLowerCase() !== role.toLowerCase() &&
                        (filteredRole.includes('Technician') ||
                            filteredRole.includes('Supervisor') ||
                            filteredRole.includes('Section Chief'))) ||
                        filteredRole.includes('CSS')) {
                        if ((addedRoles.includes(role) && !filteredRole.includes('CSS')) || (addedRoles.includes(role) && filteredRole.includes('CSS') && hasCSSOrMPF !== 'MPF')) {
                            rolesToEnable.push(filteredRole)
                        } else {
                            rolesToDisable.push(filteredRole)
                        }
                    }
                })
            } else if (role.includes('CSS')) {
                rolesToDisplay.forEach((filteredRole: string) => {
                    if (filteredRole.includes('Technician') ||
                        filteredRole.includes('Supervisor') ||
                        filteredRole.includes('Section Chief') ||
                        filteredRole.includes('Leadership')) {
                        if (addedRoles.includes(role) && hasCSSOrMPF !== 'CSS') {
                            rolesToEnable.push(filteredRole)
                        } else {
                            rolesToDisable.push(filteredRole)
                        }
                    }
                })
            }

            const allRoles = [...new Set([...rolesToDisable, ...disabledRoles])]

            setDisabledRoles(allRoles.filter((role) => !rolesToEnable.includes(role)))
        }

        removeRoles ?
            setRolesToRemove([...new Set(tempRoles)]) :
            setAddedRoles([...new Set(tempRoles)])
    }

    const handleUserCall = async (removeRoles = false) => {
        setPageOverlay(true)

        const rolesToAddOrRemove = removeRoles ?
            [...rolesToRemove] : [...addedRoles]

        for (const role of rolesToAddOrRemove) {
            const index = currentRoles.indexOf(role)
            if (index !== -1) {
                if (removeRoles) {
                    const UserToUpdate = await mpfAuthCrudHttp().GetUser(selectedValue.id)
                    rolesToRemove.forEach((removedRole) => {
                        UserToUpdate.roles = UserToUpdate?.roles
                            .filter((role) => role.indexOf(removedRole) < 0)
                    })

                    await mpfAuthCrudHttp().AddOrUpdateUser(UserToUpdate)
                }
            } else {
                if (!removeRoles) {
                    const userProfileList = await mpfRListsHttp().getList('UserProfileList')
                    const userProfile = await userProfileList.query().filter(`UserRID eq '${selectedValue.id}'`).get()

                    if ((userProfile?.length > 0 &&
                        (userProfile[0]?.AssignedComponentCode ===
                        inputValues?.assignedComponentCode || 
                        inputValues?.assignedComponentCode === -1))
                    ) {
                        await mpfAuthCrudHttp().RoleAddUser(
                            role,
                            selectedValue.id
                        )
                    } else if (userProfile?.length > 0) {
                        setCrossComponentAlert(true)
                    } else {
                        setNoProfileAlert(true)
                    }
                }
            }
        }

        setHasCSSOrMPF('')
        await fetchUsers()
        await selectedUser(searchedUser, true)
        setPageOverlay(false)
    }

    useEffect(() => {
        if (refreshRoles) {
            handleUserSearch()
            setRefreshRoles(false)
        }
    }, [selectedValue, refreshRoles])

    useEffect(() => {
        const element: any = document.getElementsByClassName('menus')
        if (btnActionshowhide.removeuser) {
            if (element && element[0]?.classList?.contains("menuexpand")) {
                Promise.all([
                    setActionbtnshowhide({ ...btnActionshowhide, removeuser: false })
                ]).then(() => {
                    setTimeout(() => {
                        showPopup()
                    }, 200)
                })
            }
            if (element && element[0]?.classList?.contains("menucollapsed")) {
                Promise.all([
                    setActionbtnshowhide({ ...btnActionshowhide, removeuser: false })
                ]).then(() => {
                    setTimeout(() => {
                        showPopup()
                    }, 200)
                })
            }
        }
    }, [isMenusExpanded])

    const showPopup = () => {
        const ele: any = document.getElementById('addremoveuser')
        const elementHeight = ele.offsetHeight
        const offSetTopValue = ele.offsetTop
        const popupTop = elementHeight + offSetTopValue
        const offsetWidthValue = ele.offsetWidth
        const offsetLeftValue = ele.offsetLeft
        const popupLeft = offsetWidthValue + offsetLeftValue
        popupCloseOpenFunctionality('removeuser', true, popupTop, popupLeft, offsetLeftValue, elementHeight, offsetWidthValue)
    }
    return (
        <div className='font-11 links my-sm-2'>
            {crossComponentAlert && <Alert
                alerttextclass='poppins-semibold font-13 text-center'
                btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
                btn1iconclassNmae='icon-checked font-12 pe-1'
                btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
                btn2iconclassNmae='icon-close color-primary font-12 pe-1'
                cancel='Cancel'
                className='alert-info'
                message={"The selected user's profile component and working component are different. Please update profile to working component."}
                onClick={() => setCrossComponentAlert(false)}
                yes='OK'
            />}
            {noProfileAlert && <Alert
                alerttextclass='poppins-semibold font-13 text-center'
                btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
                btn1iconclassNmae='icon-checked font-12 pe-1'
                btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
                btn2iconclassNmae='icon-close color-primary font-12 pe-1'
                cancel='Cancel'
                className='alert-info'
                message={'The selected user does not have a profile. Please reach out to the user or your CP Owner to create the profile.'}
                onClick={() => setNoProfileAlert(false)}
                yes='OK'
            />}
            {pageOverlay && <PageOverlayBusy />}
            <ActionButtons
                btnClassName='ps-2 border-left2 maxfitcontent'
                className={
                    btnActionshowhide?.removeuser
                        ? 'btn-border font-14 btn-border-radius p-relative popup-arrow text-nowrap color-primary'
                        : 'color-primary btn-border font-14 btn-border-radius p-relative text-nowrap'
                }
                icon='icon-user color-primary font-12 me-md-1 bold'
                id={'addremoveuser'}
                infoIcon='icon-info color-primary ps-1'
                infoLabel='Add / Remove User '
                isClick='removeuser'
                label='Add / Remove User'
                name='Add / Remove User'
                popupCloseOpenFunctionality={popupCloseOpenFunctionality}
                rIcon='tool-tip tooltip-bottom font-12 sourcesanspro'
                ref={removeuser}
                showHide={showActionPopups.removeuser}
                type='button'
            />
            {btnActionshowhide?.removeuser ? (
                <div
                    className='popup popup-md'
                    ref={popupbtnRef}
                    style={{
                        left: xpositionvalueupdate,
                        maxHeight: popupheight,
                        overflow: 'visible',
                        position: 'absolute',
                        top: popupTop + 8,
                    }}
                >
                    <div className='d-flex'>
                        <h3
                            aria-label='Search User'
                            className='font-11 poppins-medium title-color2 m-0 py-1'
                            tabIndex={0}
                        >
                            Search User
                        </h3>
                        <div className='close ms-auto'>
                            <ActionButtons
                                className='btn-bgcolor6 whitetext p-0 btn btn-sm font-0 btn-border-radius3'
                                icon='icon-close font-8 p-1'
                                isClick='removeuser'
                                label='Cancel'
                                name=''
                                popupCloseOpenFunctionality={
                                    popupCloseOpenFunctionality
                                }
                                ref={removeuser}
                                showHide={showActionPopups.removeuser}
                                type='button'
                            />
                        </div>
                    </div>
                    <div className='pt-2 d-flex align-items-center sppeoplepicker'>
                        <InputText
                            changeHandler={(e: any) =>
                                changeUser(e.target.value)}
                            className='form-lg'
                            data={peopleDropdownNames}
                            formClassName=' d-flex flex-column p-relative customautocomplete'
                            infoClassName='tool-tip tooltip-bottom font-12 sourcesanspro'
                            infoIcon='icon-info color-primary'
                            inputProps={{
                                className: 'poppins-medium font-12 title-color2 mb-1',
                                maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
                                placeholder: 'Enter Name or Email Address',
                            }}
                            isInfo
                            isMandatory
                            onSelect={(e) => selectedUser(e)}
                            type='peopel-picker'
                            value={searchedUser}
                        />
                        <Buttons
                            className='border-radius03 py-1 px-2 btn-bgcolor9  ms-2 whitetext poppins-medium font-12 btn-xs'
                            icon='icon-search font-11 pe-1'
                            label='Search'
                            onClick={() => handleUserSearch()}
                            type='button'
                        />
                    </div>
                    {searchError && <span className='errormsg'>Please Select a User.</span>}
                    {peopleDropdownNames && peopleDropdownNames.length <= 0 &&
                        searchedUser.length > 2 && !searchError && (
                            <span className='errormsg'>{'No matching user found!'}</span>
                        )}
                    {roles.length > 0 && togglePopupInfo && searchedUser !== '' ?
                        <div className='border-bottom1 mb-2 py-2'>
                            <div className='font-11 poppins-medium title-color2 pb-1'>
                                User Existing in Group(s)
                                <span
                                    className='tool-tip tooltip-top'
                                    data-tip=' Currently Assigned User Roles'
                                >
                                    <span className='icon-info color-primary ps-1'></span>
                                </span>
                            </div>
                            <div className='d-flex flex-wrap gap-1 py-1' style={{
                                maxHeight: popupheight / 3.5,
                                overflow: 'scroll'
                            }}>
                                {roles.map((role) => (
                                    <InputCheckbox
                                        className='h-auto my-1'
                                        formClassName='form-horizontal font-0'
                                        inputProps={{
                                            checked:
                                                rolesToRemove.includes(role),
                                            className:
                                                'font-10 poppins-medium title-color2 mx-2',
                                            id: role,
                                            label: role,
                                            name: 'Input Check',
                                            type: 'checkbox',
                                        }}
                                        key={role}
                                        onChange={(e) =>
                                            handleRoleChange(role, true)}
                                    />
                                ))}
                            </div>
                            {rolesToRemove.length > 0 && <div className='ms-auto d-flex w-100'>
                                <Buttons
                                    className='border-radius03 py-1 px-2 bgcolor-37 ms-2 whitetext poppins-medium font-12 btn-xs ms-auto text-uppercase'
                                    icon='icon-close font-9 pe-1'
                                    label='Remove User'
                                    onClick={(e) => handleUserCall(true)}
                                    type='button'
                                />
                            </div>}
                        </div>
                        : togglePopupInfo && selectedValue.roles.length <= 0 &&
                        <div className='border-bottom1 mb-2 py-2'>
                            <div className='font-11 poppins-medium title-color2 pb-1'>
                                User Existing in Group(s)
                                <span
                                    className='tool-tip tooltip-top'
                                    data-tip=' Currently Assigned User Roles'
                                >
                                    <span className='icon-info color-primary ps-1'></span>
                                </span>
                                <div
                                    aria-label={NORESULT}
                                    className='subtitle-color2 montserratregular'
                                    style={{ padding: '1rem', textAlign: 'center', width: '100%' }}
                                    tabIndex={0}
                                >
                                    {NORESULT}
                                </div>
                            </div>
                        </div>
                    }
                    {togglePopupInfo && searchedUser !== '' &&
                        <div className='py-2'>
                            <div className='font-11 poppins-medium title-color2 pb-1'>
                                User Role(s) Available to assign
                                <span
                                    className='tool-tip tooltip-top'
                                    data-tip=' User Role(s) Available to assign'
                                >
                                    <span className='icon-info color-primary ps-1'></span>
                                </span>
                            </div>
                            {rolesToDisplay.length > 0 ?
                                <div className='d-flex flex-wrap gap-1' style={{
                                    maxHeight: popupheight / 3.5,
                                    overflow: 'scroll'
                                }}>
                                    {rolesToDisplay.map((role: string) => (
                                        <InputCheckbox
                                            className='h-auto my-1'
                                            formClassName='form-horizontal font-0'
                                            inputProps={{
                                                checked:
                                                    addedRoles.includes(role),
                                                className:
                                                    'font-10 poppins-medium title-color2 mx-2',
                                                disabled:
                                                    disabledRoles.includes(
                                                        role
                                                    ),
                                                id: role,
                                                label: role,
                                                name: 'Input Check',
                                                type: 'checkbox'
                                            }}
                                            key={role}
                                            onChange={() =>
                                                handleRoleChange(role, false)
                                            }
                                        />
                                    ))}
                                </div>
                                :
                                <div
                                    aria-label={NORESULT}
                                    className='subtitle-color2 montserratregular'
                                    style={{ padding: '1rem', textAlign: 'center', width: '100%' }}
                                    tabIndex={0}
                                >
                                    {NORESULT}
                                </div>
                            }
                            {addedRoles.length > 0 &&
                                <div className='ms-auto d-flex w-100'>
                                    <Buttons
                                        className='border-radius03 py-1 px-2 bgcolor-9  ms-2 whitetext poppins-medium font-12 btn-xs ms-auto text-uppercase'
                                        icon='icon-checked font-9 pe-1'
                                        label='Add User'
                                        onClick={(e) => handleUserCall()}
                                        type='button'
                                    />
                                </div>
                            }
                        </div>
                    }
                </div>
            ) : (
                ''
            )}
        </div>
    )
}

export default AddRemoveUser